const SVGNS = 'http://www.w3.org/2000/svg';
const XLINKNS = 'http://www.w3.org/1999/xlink';

export function getSvgDocument(data) {
  const doc = new DOMParser();
  return doc.parseFromString(data, 'image/svg+xml');
}

export function checkIsMHubUnit(id) {
  if (id) {
    if (id.startsWith('mhub-ref:') || id.startsWith('mhub-id:')) {
      return true;
    }
  }
  return false;
}

export function checkSvgFormatValid(data) {
  const xml = getSvgDocument(data);
  const svg = xml.getElementById('mhub-svg');
  if (svg) {
    const mainGroup = xml.getElementById('mhub-site-plan');
    if (mainGroup) {
      if (mainGroup.parentNode === svg) {
        const unitGroup = xml.getElementById('mhub-units');
        if (unitGroup) {
          if (unitGroup.parentNode === mainGroup) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

export function displaySVG(data, imgURL) {
  const dataIsString = typeof data === 'string';
  const xml = dataIsString ? getSvgDocument(data) : data;
  const svgElements = xml.getElementsByTagName('svg');
  if (svgElements.length > 0) {
    const svg = svgElements[0];
    if (imgURL) {
      // get svg width height
      let svgWidth = svg.getAttribute('width');
      let svgHeight = svg.getAttribute('height');
      const svgViewBox = svg.getAttribute('viewBox');
      if (svgViewBox) {
        const viewBox = svgViewBox.split(' ');
        svgWidth = viewBox[2];
        svgHeight = viewBox[3];
      }
      // set img
      let svgImg = xml.getElementById('mhub-svg-img');
      if (!svgImg) {
        // use createElementNS to create svg element
        svgImg = xml.createElementNS(SVGNS, 'image');
        svgImg.setAttribute('id', 'mhub-svg-img');

        const siteplan = xml.getElementById('mhub-site-plan');
        if (siteplan) {
          siteplan.insertBefore(svgImg, siteplan.firstChild);
        }
      }
      if (svgImg) {
        svgImg.setAttribute('href', imgURL);
        svgImg.setAttributeNS(XLINKNS, 'xlink:href', imgURL);
        svgImg.setAttribute('xmlns:xlink', XLINKNS);
        svgImg.setAttribute('x', 0);
        svgImg.setAttribute('y', 0);
        svgImg.setAttribute('width', svgWidth);
        svgImg.setAttribute('height', svgHeight);
        svgImg.setAttribute('style', 'opacity:0.75;');
      }
    }
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
  }
  let result = xml.documentElement.outerHTML;
  if (dataIsString) {
    result = data.slice(0, data.indexOf('<svg'));
    result += xml.documentElement.outerHTML;
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/siteplanSVG.js